<template>
  <div class="p-grade">
    <header>
      <CardTitle>{{ titleName }}</CardTitle>
      <!-- <div class="tab-change">
        <p class="tab pointer">科目</p>
        <p class="tab pointer">学生</p>
      </div> -->
    </header>
    <section>
      <div class="grade-count"></div>
    </section>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import CardTitle from './card-title.vue';

export default {
  name: 'GradeCount',
  components: {
    CardTitle,
  },
  props: {
    titleName: {
      type: String,
      default: '年级分布',
    },
    userTypeList: {
      type: Array,
      default: () => [],
    },
    userTypeCount: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      subjectList: [],
    };
  },
  methods: {
    initCharts() {
      const that = this;
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.grade-count'));
      // 绘制图表
      myChart.setOption({
        legend: {
          top: 50,
          left: 280,
          data: that.userTypeList,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: 'write',
            lineHeight: 10,
          },
        },
        series: [
          {
            type: 'pie',
            radius: [15, 80],
            center: ['28%', '50%'],
            roseType: 'area',
            label: {
              normal: {
                position: 'inner',
                show: false,
              },
            },
            itemStyle: {
              borderRadius: 2,
            },
            data: this.userTypeCount,
          },
        ],
      });
    },
  },
  mounted() {
    this.initCharts();
  },
};
</script>
<style lang="scss" scoped>
.p-grade {
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  width: 400px;
  height: 300px;
  background: url("~@/views/pt/images/exhibition-grade.png") no-repeat left top /100% 100%;
  .tab-change {
    width: 130px;
    height: 32px;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0px 8px 8px 0px rgba(0, 61, 163, 0.22),
      0px -8px 8px 0px rgba(0, 61, 163, 0.27),
      8px 0px 8px 0px rgba(0, 61, 163, 0.22),
      -8px 0px 8px 0px rgba(0, 61, 163, 0.27);
    border-radius: 4px;
    border: 2px solid;
    border-image: linear-gradient(
        273deg,
        rgba(53, 162, 255, 0.19),
        rgba(118, 223, 255, 1),
        rgba(75, 143, 255, 0.31)
      )
      2 2;
    position: absolute;
    top: 20px;
    right: 60px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .tab {
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #e0efff;
      line-height: 20px;
    }
  }
  .grade-count {
    width: 360px;
    height: 250px;
    background: url("../../images/exhibition_radius.png") no-repeat center left /100% 100%;
    background-size: 201px;
  }
}
</style>
